import * as THREE from "three";
import {StrokeGenerator} from "./stroke_generator";
import {Rectangle, Point} from "./shapes";
import "./palette_manager";
import {HEADER_HEIGHT, settings} from "./palette_manager";

import {LitElement, html} from "@polymer/lit-element";

const CANVAS_WIDTH = 500;
const CANVAS_HEIGHT = 500; // -HEADER_HEIGHT

let canvas = document.querySelector("canvas");

class WebGLCanvas extends LitElement {
    render() {
        return html`
            <style>
                canvas {
                    touch-action: none;
                    border: 1px solid #000;
                    transform-origin: 50% 50%;
                }
            </style>
            <canvas></canvas>
        `;
    }

    firstUpdated() {
        const canvas = this.shadowRoot.querySelector("canvas");
        initCanvas(canvas);
    }
}

customElements.define("webgl-canvas", WebGLCanvas);

function initCanvas(canvas) {
    const contextAttributes = {
        "lowLatency": true,
        "antialias": true,
        "alpha": false,

        "majorVersion": 2,
        "minorVersion": 0,
        "preserveDrawingBuffer": true,
    };
    let ctx = canvas.getContext("webgl2", contextAttributes);

    let renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        context: ctx,
        clearColor: 0xff0000,
        alpha: false,
    });

    renderer.setPixelRatio( window.devicePixelRatio );
    renderer.setSize( CANVAS_WIDTH, CANVAS_HEIGHT );
    renderer.autoClear = false;

    // Set up camera
    let camera = new THREE.OrthographicCamera(0,CANVAS_WIDTH,0,CANVAS_HEIGHT);
    camera.position.set( 0, 0, 100 );
    camera.lookAt( new THREE.Vector3( 0, 0, 0 ) );

    // Create a scene
    let scene = new THREE.Scene();
    scene.background = new THREE.Color( 0xffffff );

    function render() {
        renderer.render(scene, camera);
    }


    let partialRect = null;
    function requestPartialRender(rect) {
        if(!partialRect) {
            partialRect = rect;
            //window.requestAnimationFrame(renderPartial);
        } else {
            partialRect = partialRect.union(rect);
        }
        renderPartial();
    }
    function renderPartial() {
        renderer.setScissorTest(true);
        // console.log(partialRect.min.x, partialRect.min.y, partialRect.width, partialRect.height);
        renderer.setScissor(partialRect.min.x, partialRect.min.y, partialRect.width, partialRect.height);
        renderer.render(scene, camera);
        renderer.setScissorTest(false);

        partialRect = null;
    }

    render();

    let el = renderer.domElement;
    // el.addEventListener("touchstart", (e) => e.preventDefault());

    function wrapHandler(fn) {
        return function(e) {
            // if(e.pointerType == "pen") {
                fn(e);
            // }
        };
    }

    function _getPoint(e) {
        if(settings.flipped) {
            return {x: e.clientX, y: CANVAS_HEIGHT - e.clientY};
        }
        return {x: e.clientX, y: e.clientY - HEADER_HEIGHT};
    }

    let generator = null;
    el.addEventListener("pointerdown", e => {
        let p = _getPoint(e);

        generator = new StrokeGenerator();
        generator.down(p);
        scene.add(generator.el);

        requestPartialRender(Rectangle.fromPoint(p).expand(5));
    });
    el.addEventListener("pointermove", e => {
        if(!settings.raw) {
            if(e.pointerType != "mouse" || (e.buttons & 1)) {
                let dirtyRect = null;
                
                e.getCoalescedEvents().forEach(e => {
                    let r = generator.move(_getPoint(e));
                    if(dirtyRect) {dirtyRect = dirtyRect.union(r);}
                    else {dirtyRect = r;}
                });
                requestPartialRender(dirtyRect.expand(2));
            }
        }
    });
    el.addEventListener("pointerrawmove", e => {
        if(settings.raw) {
            if(e.pointerType != "mouse" || (e.buttons & 1)) {
                let dirtyRect = null;
                
                e.getCoalescedEvents().forEach(e => {
                    let r = generator.move(_getPoint(e));
                    if(dirtyRect) {dirtyRect = dirtyRect.union(r);}
                    else {dirtyRect = r;}
                });
                requestPartialRender(dirtyRect.expand(2));
            }
        }
    });
    el.addEventListener("pointerup", e => {
    generator.up();
    render();
    });


    const clearButton = document.querySelector("#clear-button");
    clearButton.addEventListener("click", () => {
        while(scene.children.length > 0){ 
            scene.remove(scene.children[0]); 
        }
        render();
    });
}